/**
 * User-facing model name from a Bedrock / LangChain model id (e.g.
 * ``bedrock/us.anthropic.claude-sonnet-4-5-20250929-v1:0`` → ``Claude Sonnet 4.5``).
 */
export function formatBedrockModelDisplayLabel(modelUsed?: string | null): string | null {
  if (!modelUsed?.trim()) return null
  const key = modelUsed.trim().toLowerCase()

  const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()

  // Claude 4.x / Haiku 4.5 style: ...claude-sonnet-4-5-20250929...
  const snap = key.match(/claude-(sonnet|opus|haiku)-(\d+)-(\d+)-(\d{8})/)
  if (snap) {
    return `Claude ${cap(snap[1])} ${snap[2]}.${snap[3]}`
  }

  // e.g. claude-opus-4-6-v1:0 (no 8-digit snapshot in id)
  const majMin = key.match(/claude-(sonnet|opus|haiku)-(\d+)-(\d+)(?:-v\d|$)/)
  if (majMin && majMin[3].length <= 2) {
    return `Claude ${cap(majMin[1])} ${majMin[2]}.${majMin[3]}`
  }

  // Legacy: claude-sonnet-4-20250514
  const legacy = key.match(/claude-(sonnet|opus|haiku)-(\d+)-(\d{8})/)
  if (legacy) {
    return `Claude ${cap(legacy[1])} ${legacy[2]}`
  }

  // Claude 3.x: claude-3-7-sonnet-...
  const three = key.match(/claude-3-(\d+)-(sonnet|opus|haiku)/)
  if (three) {
    return `Claude ${cap(three[2])} 3.${three[1]}`
  }

  // Claude 3.5: claude-3-5-sonnet-...
  const half = key.match(/claude-3-5-(sonnet|opus|haiku)/)
  if (half) {
    return `Claude ${cap(half[1])} 3.5`
  }

  if (key.includes('deepseek')) return 'DeepSeek'

  return null
}
